import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
};

const TelephoneIcon = ({ color = '#B5BCBD', size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M23.573 17.487a143.396 143.396 0 0 0-4.752-2.479c-.641-.321-1.167-.088-1.57.522-.387.585-.771 1.177-1.186 1.741-.658.895-1.05.992-2.03.561-3.327-1.465-5.804-3.968-7.662-7.229-.31-.543-.302-1.019.105-1.501.463-.552.966-1.083 1.327-1.708.209-.361.345-.956.217-1.326C7.41 4.296 6.71 2.558 6.003.823 5.89.543 5.62.204 5.371.149 4.159-.115 2.962-.12 1.994.905.666 2.306.03 4.017 0 6.013c.034.383.048.765.105 1.144.324 2.218 1.378 4.065 2.547 5.87 3.42 5.279 7.81 9.083 13.712 10.697 1.951.534 3.736.31 5.458-.81 1.64-1.068 2.197-2.694 2.177-4.626 0-.277-.208-.68-.426-.801z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

TelephoneIcon.propTypes = propTypes;

export default TelephoneIcon;
